import React from 'react'
import type { JSX } from 'react'

export function TitleBarIconButton({
  children,
  ...buttonHTMLAttributes
}: { readonly children: React.ReactNode } & Omit<
  JSX.IntrinsicElements['button'],
  // Omitted because not allowed:
  'disabled' // Avoid 'disabled' since it's not accessibility friendly. Use 'aria-disabled' instead.
>) {
  return (
    <button
      {...buttonHTMLAttributes}
      className={'cursor-pointer py-2'}
      type={'button'}
    >
      {children}
    </button>
  )
}
